var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$ms.commonFunc.checkCurrentPassedNumberDay())?_c('div',{staticClass:"tag-new-feature"},[_vm._v("\n\t"+_vm._s(_vm.$t('i18nNotification.NotificationTooltip.TagNew'))+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }